import { h, Component } from "preact";
import { translate } from "react-i18next";

class LinkServiceCard extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className={"c-LinkServiceCard " + this.props.name}>
        <img src={this.props.image} alt={this.props.name} />
        <div className="service-name">{this.props.name}</div>
        <div className="service-username">{this.props.name !== "Amazon" ? this.props.username : ""}</div>
        <div className="rewards-wrapper">
          <p>{this.props.rewardsString !== false ? t("In-Game Rewards:") : ""}</p>
          <div className="service-rewards">{this.props.rewardsString}</div>
        </div>
        {this.props.linked === true && !["Google", "Facebook", "Steam", "Epic Games"].includes(this.props.name) && (
          <div className="button unlink" onClick={() => this.props.disconnectCallback(this.props.portal)}>
            {t("Unlink Account")}
          </div>
        )}
        {this.props.linked === false && (
          <a className="button link" href={this.props.url}>
            {t("Link Account")}
          </a>
        )}
      </div>
    );
  }
}

export default translate(["common"], { withRef: true })(LinkServiceCard);



// WEBPACK FOOTER //
// ./components/LinkServiceCard.js